<template>
  <div class="firm_container">
    <div class="firm_Main_body">
      <!-- 头部导航栏 -->
      <div class="Navigation_con1">
        <NavFirm :navNum="1" @handleWarn="handleWarn"></NavFirm>
      </div>
      <div class="firm-nav-table">
        <div class="nav-left">
          <div class="menu-box">
            <div class="menu-title" @click="goBack">
              <img
                class="title-img"
                src="@/assets/imgs/back-da@3x.svg"
                alt=""
              />
              <span class="title-text">返回首页</span>
            </div>
            <div
              v-for="(item, index) in menuList"
              :key="item.id"
              @click="routerChange(index, item)"
              :class="
                selIndex != index ? 'menu-box-item-yes' : 'menu-box-item-no'
              "
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="nav-right">
          <div class="guest-content-wrap" :class="{ 'is-blurred': isGuest }">
            <div
              style="
                width: 1200px;
                min-height: calc(100vh - 60px);
                margin: 0 auto;
                padding-top: 30px;
                box-sizing: border-box;
              "
            >
              <router-view></router-view>
            </div>
          </div>
          <GuestLockMask v-if="isGuest" :blur-mode="true" />
          <!-- 账号注销提示弹窗 -->
          <SignOut
            :dialogSignOut="dialogSignOut"
            @handleClose="handleClose"
            @handleUnderstand="handleUnderstand"
          >
          </SignOut>
        </div>
      </div>

      <!-- 右侧反馈   客服 -->
      <!-- <div class="right_btn">
            <IndexRight></IndexRight>
          </div> -->
    </div>
  </div>
</template>

<script>
// 账号注销提示弹窗
import SignOut from "../../personage/home/components/Popup/SignOut.vue";
import NavFirm from "../../../components/NavFirm.vue";
import GuestLockMask from "../firmCenter/components/GuestLockMask.vue";
export default {
  props: {},
  components: {
    NavFirm,
    SignOut,
    GuestLockMask,
  },
  data() {
    return {
      scroll: "",
      scrollType: "1",
      searchType: "",
      dialogSignOut: false,
      
      // 原始菜单（带权限标识）
      menuListOrigin: [
        {
          name: "招聘道具",
          url: "/Firm/propHire",
          id: 1,
          val:'company:prop:hire',
        },
        {
          name: "VIP",
          url: "/Firm/propVip",
          id: 2,
          val:'company:prop:vip',
        },
      ],
      
      menuList: [], // 权限过滤后最终显示的菜单
      selIndex: 0,
    };
  },
  computed: {
    isGuest() {
      const user = this.$store.getters.getUser;
      return !(user && user.id);
    },
  },
  watch: {
    scroll(newss) {
      this.scrollType = newss > 80 ? "2" : "1";
    },
  },
  created() {
    this.initMenuByPermission();
    this.$bus &&
      this.$bus.$on("admin-permission-updated", this.initMenuByPermission);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  beforeDestroy() {
    this.$bus &&
      this.$bus.$off("admin-permission-updated", this.initMenuByPermission);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // ==================== 权限过滤 + 自动跳转 ====================
    initMenuByPermission() {
      // 未登录预览：展示全部菜单
      if (this.isGuest) {
        this.menuList = this.menuListOrigin.slice();
        const currentPath = this.$route.path;
        const idx = this.menuList.findIndex((m) => m.url === currentPath);
        if (idx >= 0) {
          this.selIndex = idx;
        } else {
          this.selIndex = 0;
          this.$router.replace(this.menuList[0].url);
        }
        return;
      }

      // 1. 获取权限
      let permStr = localStorage.getItem("permissionCodes");
      let perm = [];
      try { perm = JSON.parse(permStr) } catch (e) {}

      // 2. 过滤菜单
      this.menuList = this.menuListOrigin.filter(item => {
        return item.val && perm.includes(item.val);
      });

      // 3. 无菜单 → 不处理
      if (this.menuList.length === 0) return;

      // 4. 当前路由是否合法
      const currentPath = this.$route.path;
      const hasCurrent = this.menuList.some(m => m.url === currentPath);

      if (hasCurrent) {
        // 有当前页面权限 → 高亮正确
        this.selIndex = this.menuList.findIndex(m => m.url === currentPath);
      } else {
        // 无当前页面权限 → 自动跳转到第一个有权限的菜单
        this.selIndex = 0;
        this.$router.replace(this.menuList[0].url);
      }
    },

    // 打开注销弹窗
    handleWarn() {
      this.dialogSignOut = true;
    },
    handleClose() {
      this.dialogSignOut = false;
    },
    handleUnderstand() {
      this.dialogSignOut = false;
      this.$router.push("/login");
    },

    // 返回首页
    goBack() {
      this.$router.push(this.isGuest ? "/Choice" : "/FirmHomePage");
    },

    // 滚动
    handleScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },

    // 菜单点击
    routerChange(index, item) {
      this.selIndex = index;
      this.$router.push(item.url);
    },
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/css/firmEachIndex.css";

.firm_container {
  .firm_Main_body {
    .firm-nav-table {
      display: flex;

      .nav-left {
        width: 200px;
        padding: 10px 0;
        box-sizing: border-box;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        color: #333;
        background-color: #fff;

        .menu-box {
          .menu-title {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            background: rgba(97, 144, 232, 0.3);
            border-radius: 10px;
            font-size: 20px;
            color: #409eff ;
            margin: 10px 10px 20px;
            cursor: pointer;

            .title-img {
              margin: 2px 10px 0 0;
            }
            .title-text {
              font-size: 20px;
            }
          }

          .menu-box-item-yes {
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #fff;
            border-radius: 5px;
            font-size: 16px;
            margin: 8px 10px;
            cursor: pointer;
            color: #333;
          }

          .menu-box-item-no {
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #eeeeee;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            margin: 8px 10px;
            color: #409eff ;
          }
        }
      }

      .nav-right {
        position: relative;
        flex: 1;
        background: rgba(97, 144, 232, 0.1);
        border-radius: 50px 0px 0px 50px;
      }
    }
  }
}
.guest-content-wrap.is-blurred {
  height: calc(100vh - 60px);
  max-height: calc(100vh - 60px);
  overflow: hidden;
  pointer-events: none;
  user-select: none;
}
.guest-content-wrap.is-blurred /deep/ .firm-Content-subject > * {
  opacity: 0.5;
  filter: blur(2.5px);
}
/* 无 firm-Content-subject 的子页：模糊内容容器，避免糊掉自身边框 */
.guest-content-wrap.is-blurred > div {
  opacity: 0.55;
  filter: blur(2px);
}
</style>
